import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    title: {
      lineHeight: 1.5,
      color: theme.colors.common15,
      fontWeight: 500,
    },
    iconButton: {
      color: theme.colors.common14,
      backgroundColor: theme.colors.common11,
      border: `1px solid ${theme.colors.common14}`,
      margin: theme.spacing(0, 1),
      width: '50px',
      height: '50px',
      boxShadow: '0 0.5px 1.5px 0 rgba(0, 0, 0, 0.2)',
      [theme.breakpoints.down('sm')]: {
        borderRadius: '4px',
        display: 'block',
        marginBottom: '10px',
        padding: theme.spacing(1.5),
        width: '250px',
        margin: '0 auto',
        height: 'auto',
      },
    },
    icon: {
      color: theme.colors.common14,
      marginTop: '2px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    text: {
      display: 'none',
      color: theme.colors.common14,
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        textTransform: 'uppercase',
        fontWeight: 700,
        fontSize: '13px',
      },
    },
  };
};
